<template>
      <a-col>
        <div class="provisioning_success_container">
            <a-button block class="green_bg step_btn" size="large" @click.prevent="enterMonitorPage">進入監控畫面</a-button>
        </div>
      </a-col>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        methods: {
            enterMonitorPage() {
                this.$router.push(`/individual/monitor`);
            }
        },
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global.scss";

  .provisioning_success_container {
      margin-top: 12px;
  }
</style>